
import { Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSupabaseAuth } from "@/contexts/SupabaseAuthContext";
import { useCurrentProfile } from "@/hooks/useSupabaseProfile";

interface AuthHeaderProps {
  onSettingsClick: () => void;
}

const AuthHeader = ({ onSettingsClick }: AuthHeaderProps) => {
  const { user } = useSupabaseAuth();
  const { data: profile } = useCurrentProfile(user?.id);
  const isAdmin = user?.user_metadata?.isAdmin || user?.user_metadata?.is_super_admin || profile?.is_admin;

  return (
    <div className="absolute top-0 right-0 p-4">
      {isAdmin && (
        <Button 
          variant="ghost" 
          size="icon"
          className="text-purple-600 hover:text-purple-700 hover:bg-purple-100"
          onClick={onSettingsClick}
        >
          <Settings className="h-5 w-5" />
        </Button>
      )}
    </div>
  );
};

export default AuthHeader;
